module.exports = __webpack_public_path__ + "img/img37.b424dbac.jpg";